import { inject } from 'mobx-react';
import { IObservableArray } from 'mobx';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { ImageViewModel } from 'models';

import { ToolbarType, UitkOverlayToolbar } from 'uitk-react-toolbar';
import { UitkFullscreenDialog, UitkFullscreenDialogTheme } from 'uitk-react-dialog';
import { UitkMediaGalleryImageDialog, UitkMediaGalleryImageView } from 'uitk-react-media-gallery';

import { GallerySwipe } from 'components/common/media/gallery-swipe';

interface GalleryDialogProps extends LocalizedComponentProps {
  analytics?: AnalyticsStore;
  currentIndex: number;
  galleryDialogCloseCallback?: () => void;
  galleryDialogOpenCallback?: () => void;
  galleryName: string;
  images: IObservableArray<ImageViewModel> | ImageViewModel[];
  onIndexChange: (index) => void;
  trackingRfrr: string;
  isInfositeGallery?: boolean;
}

const GalleryDialogComponent = ({
  analytics,
  currentIndex,
  galleryDialogCloseCallback,
  galleryName,
  images,
  l10n,
  onIndexChange,
  trackingRfrr,
  isInfositeGallery
}) => {
  const [showDialog, setShowDialog] = React.useState<boolean>(false);

  React.useEffect(() => {
    setShowDialog(true);
  }, []);

  const toolBarAttributes = {
    iconLabel: l10n.formatText('hotels.infosite.amenities.cancelButton.a11yLabel'),
    type: ToolbarType.CLOSE
  };

  const toolbarAnalytics = analytics.setupTracker(trackingRfrr, 'Close review gallery dialog');
  const mediaGalleryControlsAnalytics = analytics.setupTracker(trackingRfrr, 'Change image in media gallery');
  const customGalleryDialog = (
    <UitkFullscreenDialog dialogShow={showDialog} theme={UitkFullscreenDialogTheme.DARK} strictFullscreen={true}>
      <div className="gallery-dialog">
        <UitkOverlayToolbar {...toolBarAttributes} analytics={toolbarAnalytics} action={galleryDialogCloseCallback} />
        <section key="gallery-dialog__content" className="gallery-dialog__wrapper">
          <GallerySwipe
            galleryName={galleryName}
            images={images}
            currentIndex={currentIndex}
            onIndexChange={onIndexChange}
            enableKeyboardNavigation={true}
          />
        </section>
      </div>
    </UitkFullscreenDialog>
  );

  return !isInfositeGallery ? (
    <React.Fragment>{customGalleryDialog}</React.Fragment>
  ) : (
    <UitkMediaGalleryImageDialog
      dialogShow={showDialog}
      {...toolBarAttributes}
      analytics={toolbarAnalytics}
      onDismiss={galleryDialogCloseCallback}
    >
      <UitkMediaGalleryImageView
        images={images}
        currentIndex={currentIndex}
        onIndexChange={onIndexChange}
        galleryName={galleryName}
        analytics={mediaGalleryControlsAnalytics}
      />
    </UitkMediaGalleryImageDialog>
  );
};

export const GalleryDialog = withLocalization(inject('analytics')(GalleryDialogComponent)) as React.ComponentType<GalleryDialogProps>;
